import { type JSX } from 'preact';
import { useEffect, useState } from 'preact/hooks';
import { getVersion } from '../api';
import { navigateTo } from '../App';

export function Footer(): JSX.Element {
  const [version, setVersion] = useState<{
    version: string;
    commit: string;
    buildDate: string;
  } | null>(null);

  useEffect(() => {
    const fetchVersion = async (): Promise<void> => {
      try {
        const versionInfo = await getVersion();
        setVersion(versionInfo);
      } catch (error) {
        console.error('Failed to fetch version:', error);
        // Silently fail - version is not critical
      }
    };

    fetchVersion();
  }, []);

  const handlePrivacyClick = (e: JSX.TargetedMouseEvent<HTMLAnchorElement>): void => {
    e.preventDefault();
    navigateTo('/privacy');
  };

  return (
    <footer className="bg-gray-100 dark:bg-gray-900 border-t border-gray-200 dark:border-gray-800 mt-12 transition-colors duration-200">
      <div className="max-w-6xl mx-auto px-4 py-6">
        <div className="text-center text-gray-600 dark:text-gray-400 text-sm transition-colors duration-200">
          <p className="mb-2">A zero-knowledge service for secure secret sharing</p>
          <p className="mb-2">
            <a
              href="/privacy"
              onClick={handlePrivacyClick}
              className="text-blue-600 dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-300 hover:underline transition-colors duration-200"
            >
              Privacy Policy
            </a>
          </p>
          {version && (
            <p className="text-xs text-gray-500 dark:text-gray-500 transition-colors duration-200">
              Version {version.version}
              {' • '}
              <span title={`Commit: ${version.commit}\nBuilt: ${version.buildDate}`}>
                {version.commit.substring(0, 7)}
              </span>
            </p>
          )}
        </div>
      </div>
    </footer>
  );
}
